export default {
  defaultPrivatePage: '/app/charts',
  signUpPage: '/signup',
  dashboardsPage: '/dashboards',
  chartsPage: '/app/charts'
};